// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__ChRMX","rotate":"Loader_rotate__5rx6A","prixClipFix":"Loader_prixClipFix__SXOyO","overlay":"Loader_overlay__JUTOi"};